import { Page } from '@roc/feature-app-core';
import {
  DocumentLibraryName,
  DocumentLibraryPlatformUi,
} from 'libs/feature-document-library-contentful/src/documentLibrary/components/documentLibraryPlatformUi';
import { HtmlDocument } from 'libs/feature-document-library-contentful/src/documentLibrary/components/htmlDocument';
import { Route } from 'react-router';
import { useRocInternalPortalStore } from '../../../hooks';

const DOCUMENT_PATH = ':contentId';

export const getDocumentLibraryInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
  portalId = null,
  nportalInternal?: string,
) => {
  return {
    documentLibraryHome: {
      path: `${basePath}/document-library-home`,
      url: `${baseUrl}/document-library-home`,
      documentTitle: 'Document Library-home'
    },
    documentLibraryDocument: (contentId?: string) => ({
      path: `${basePath}/document-library/${DOCUMENT_PATH}`,
      url: `${baseUrl}/document-library/${contentId}`,
      documentTitle: `Document Library - ${contentId}`
    }),
    documentLibraryDocumentPreview: (contentId?: string) => ({
      path: `${basePath}/document-library/${DOCUMENT_PATH}/preview`,
      url: `${baseUrl}/document-library/${contentId}/preview`,
      documentTitle: `Document Library - ${contentId} - Preview`
    }),
  };
};

export const getDocumentLibraryInternalRoutes = (basePath: string, baseUrl: string, portalId = null, nportalInternal?: string, lenderId?: string) => {
  const config = getDocumentLibraryInternalRoutesConfig(basePath, baseUrl, portalId, nportalInternal);
  const { documentLibraryStoreNew } = useRocInternalPortalStore();

  // nportal picks the lender in its own screen and hands it over in the url.
  // Without one the library reads every company, which is what ROC staff get.
  const selectedLenderId = Number(lenderId) > 0 ? Number(lenderId) : undefined;

  return {
    documentLibraryHome: (
      <Route exact path={config.documentLibraryHome.path}>
        <Page routeDefinition={config.documentLibraryHome}>
          <DocumentLibraryPlatformUi
            library={DocumentLibraryName.INTERNAL}
            manage
            hideVisibility={false}
            lenderId={selectedLenderId}
          />
        </Page>
      </Route>
    ),
    documentLibraryDocument: (
      <Route exact path={config.documentLibraryDocument().path}>
        <HtmlDocument documentLibraryStoreNew={documentLibraryStoreNew} />
      </Route>
    ),
    documentLibraryDocumentPreview: (
      <Route exact path={config.documentLibraryDocumentPreview().path}>
        <HtmlDocument preview documentLibraryStoreNew={documentLibraryStoreNew} />
      </Route>
    ),
  };
};
